export default "data:text/markdown;base64,"